import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useAuthContext } from "../../hooks/useAuthContext";
import { ApiConnectionString } from "../../constants/ApiConntection";
import LoadingSpinner from "../../components/LoadingSpinner";
import ViewPendingProducts from "./pendingProds/ViewPendingProducts";
import CreatePendingProduct from "./pendingProds/CreatePendingProduct";
import MainPage from "./pendingProds/MainPage";
import OnePendingProduct from "./pendingProds/OnePendingProduct";
import UpdatePendingProduct from "./pendingProds/UpdatePendingProduct";

// import ProductCreatedModal from "./modals/ProductCreatedModal";

export default function Products({ pendingclub,reviewPendingClub,changeMainView }) {

 

 const [currentView, setCurrentView] = useState("mainPage");
 const [recurring,setRecurring] = useState(false)
 const [pendingProdId,setPendingProdId] = useState(null);
 const selectProduct = (id,view) => {
  setPendingProdId(id);
  setCurrentView(view)
 }

 const changeView = (view) => {
setCurrentView(view)
 }
 const changeRecurring = (recurring) => {
  setRecurring(recurring)
 }

  const renderComponent = () => {
    switch (currentView) {
      case "mainPage":
        return (
        <MainPage changeView={changeView} changeRecurring={changeRecurring} selectProduct={selectProduct} changeMainView={changeMainView}/>
        );

      case "createProduct":
        return (
     <CreatePendingProduct pendingclub={pendingclub} recurring={recurring} changeRecurring={changeRecurring} changeView={changeView} reviewPendingClub={reviewPendingClub}/>
        );
      case "updateProduct":
        return (
      <UpdatePendingProduct pendingProdId={pendingProdId} changeView={changeView} />
        );
      case "ViewOneProduct":
        return (
        
          <OnePendingProduct pendingProdId={pendingProdId} changeView={changeView}  selectProduct={selectProduct}/>
         
        );
    
      default:
        return null;
    }
  };


return(
     <div>{renderComponent()}</div>

)



 
  }

